import React, { Fragment, useEffect, useRef, useState } from "react";
import { Modal, Button, Spinner } from "react-bootstrap";

// The ordering app is cross-origin, so a failed load can't be detected directly; if the iframe
// hasn't fired onLoad within this time, offer Retry instead of leaving a blank modal.
const IFRAME_LOAD_TIMEOUT_MS = 30000;

const PropertyList = ({
	handlePropertyModalOpen,
	handlePropertyModalClose,
	orderingUrl,
}) => {
	const [loading, setLoading] = useState(true);
	const [failed, setFailed] = useState(false);
	const [reloadKey, setReloadKey] = useState(0);
	const timerRef = useRef(null);

	useEffect(() => {
		if (!orderingUrl) return undefined;
		setLoading(true);
		setFailed(false);
		timerRef.current = setTimeout(() => setFailed(true), IFRAME_LOAD_TIMEOUT_MS);
		return () => clearTimeout(timerRef.current);
	}, [orderingUrl, reloadKey]);

	const handleLoad = () => {
		clearTimeout(timerRef.current);
		setLoading(false);
		setFailed(false);
	};

	return (
		<Fragment>
			<Modal show={handlePropertyModalOpen} className="customModalWidth" onHide={handlePropertyModalClose} centered id="orderplace">
				<Modal.Body className="p-0 text-center">
					{orderingUrl &&
						<div className="position-relative">
							{loading && !failed &&
								<div className="ordering-iframe-status" role="status">
									<Spinner animation="border" style={{ color: "#2D831F" }} />
									<span className="visually-hidden">Loading ordering…</span>
								</div>
							}
							{failed &&
								<div className="ordering-iframe-status" role="alert">
									<div className="bg-white rounded shadow p-4">
										<p className="mb-3">The ordering page is taking too long to load or is unavailable.</p>
										<Button variant="primary" className="me-2" onClick={() => setReloadKey((k) => k + 1)}>Retry</Button>
										<Button variant="secondary" onClick={handlePropertyModalClose}>Close</Button>
									</div>
								</div>
							}
							<iframe
								key={reloadKey}
								title="Place an order"
								width="100%"
								src={orderingUrl}
								onLoad={handleLoad}
								// src={`http://192.168.1.108/ordering/ordering-system/property-options.html?hash=b8fb02b4-b247-41ab-b4e2-5d6519b11e1b&contactinfoid=14774&uniqueChannelName=ee52c4c0-2b3b-44db-853e-e67f22c1234d`}
							/>
						</div>
					}
				</Modal.Body>
			</Modal>
		</Fragment>
	)
};

export default PropertyList;
